import React from 'react';
import { isRenu } from '../utils/ui.utils';

function SpecificInterior(props){
  const { lotSpecies, lotSourcing, t } = props;

  if (isRenu(lotSpecies)) {
    return (
      <div className="rds-desc">
        <p>{t("origin.descriptions.renu.p1")}</p>
        <p>{t("origin.descriptions.renu.p2")}</p>
        <p>{t("origin.descriptions.renu.p3")}</p>
        <p>{t("origin.descriptions.renu.p4")}</p>
      </div>
    );
  }

  return (
    <div className="rds-desc">
      <p>{t(`origin.descriptions.${lotSourcing}`)}</p>
    </div>
  );
}

function Origin(props){
  const { lotOrigin, lotSpecies, t, changeWord } = props;
  const safeLotSpecies = lotSpecies || "";
  const safeLotOrigin = lotOrigin || "";
  let   lotSourcing  = 0;

  //handle sourcing locations logic here
  if(isRenu(safeLotSpecies)){
    lotSourcing = "Renu";	  
  }else if(safeLotSpecies.includes('Goose')){	
    if(safeLotOrigin.includes('Hungary')){
	  lotSourcing = safeLotSpecies.includes('White') ? "WGD_HU" : "GGD_HU";
    }else if(safeLotOrigin.includes('Europe')){
      lotSourcing = safeLotSpecies.includes('White') ? "WGD_EU" : "GGD_EU";
    }else{
	  lotSourcing = safeLotSpecies.includes('White') ? "WGD_CN" : "GGD_CN";
    }
  }else{
    //duck
    if(safeLotOrigin.includes('Hungary')){
	  lotSourcing = safeLotSpecies.includes('White') ? "WDD_HU" : "GDD_HU";
    }else if(safeLotOrigin.includes('Europe')){
      lotSourcing = safeLotSpecies.includes('White') ? "WDD_EU" : "GDD_EU";
    }else{
	  lotSourcing = safeLotSpecies.includes('White') ? "WDD_CN" : "GDD_CN";
    }
  }

  let locationID;   

  if (isRenu(lotSpecies)) {
    locationID = t("origin.label");
  } else {
    const locKey = lotOrigin.includes('Hungary') ? 'Hungary' : 
                   (lotOrigin.includes('Europe') ? 'Europe' : 'Chinese');
    locationID = t(`origin.locations.${locKey}`);
  }

  return <div className="content-ac or hide">
		 <input
		   className="ac-input top"
		   id="ac-2afd"
		   name="ac-2afd"
		   data-id="2400"
		   data-slug="ORIGIN"
		   type="checkbox"
		   onChange={ () => changeWord('ORIGIN') }
		 />
		 <label className="ac-label" htmlFor="ac-2afd">{ locationID }</label>
		 <article className="ac-text ac-2afd"><div className="single-post-interior" tabIndex="0">	
		   	 { !(lotSpecies && lotSpecies.toLowerCase().includes("renu")) && (
           <ul className="origin-regions">
             {(() => {
               const regions = t(`origin.regions.${lotSourcing}`, { returnObjects: true });
               return Array.isArray(regions) ? regions.map((region, i) => (
                 <li key={i}>{region}</li>
               )) : null;
             })()}
           </ul>
         )}
			 <SpecificInterior
		       lotSpecies  = { lotSpecies }		       
		       lotOrigin   = { lotOrigin }
		       lotSourcing = { lotSourcing }
           t={t}
		     />
		 </div></article>
		</div>		
}

export default Origin;